import { WhistleblowerComment } from "@/models/WhistleblowerComment";

export const WhistleblowerCommentRequest = (argWhistleblowerComment) => {
  let whistleblowercomment = argWhistleblowerComment.copy();
  return whistleblowercomment;
};

export const WhistleblowerCommentResponse = (whistleblowercomment) => {
  return new WhistleblowerComment(whistleblowercomment);
};

export const WhistleblowerCommentsResponse = (whistleblowercomments) => {
  return whistleblowercomments.map((c) => WhistleblowerCommentResponse(c));
};
